<template>
    <!--    服务认证-->
    <div id="ServiceAuth">
        <h2 class="service-title">身份信息安全验证</h2>
        <div class="service-desc">为了保障您的服务权益~</div>
        <div class="service-tip">需要完成<strong>身份证</strong>以及<strong>执业证书</strong>或<strong>资格证书</strong>的认证！</div>

        <van-collapse v-model="activeIndex" accordion class="authCollapse" @change="changeAuth">
            <van-collapse-item
                v-for="(authInfo, index) in allAuthList"
                :key="authInfo.id"
                :name="index+1"
                :border="false"
                :disabled="authInfo.auditStatus==3"
                class="collapse-mdl">
                <div slot="title">
                    <div class="major_title">{{authInfo.certificateName}}</div>
                    <div class="sub_title">仅用于核实个人身份</div>
                </div>
                <div class="btn_title" slot="right-icon">
                    <span v-if="authInfo.auditStatus==1">审核通过</span>
                    <span v-else-if="authInfo.auditStatus==3" class="review">审核中</span>
                    <span v-else>点击认证</span>
                    <img class="arrow arrow_rotate" src="./img/arrow_double.png" alt="">
                </div>
                <div class="auth-content">
                    <div v-if="authInfo.auditStatus==1" class="done">
                        <van-cell
                            v-for="(disItem, disIndex) in authInfo.disFiledList"
                            :key="disIndex"
                            :title="disItem.name"
                            :value="disItem.value"
                            :disabled="true"
                            class="done-cell"/>
                        <div class="picture-list">
                            <div class="picture" @click="lookImage(disIndex)" v-for="(disItem, disIndex) in authInfo.disImgList" :key="disIndex">
                                <van-image
                                    width="100%"
                                    height="100%"
                                    fit="cover"
                                    :src="disItem"
                                />
                            </div>
                        </div>
                    </div>
                    <div v-else class="undone">
                        <template v-for="(item, cellIndex) in authInfo.authTemForm">
                            <van-cell v-if="item.flag === 1" :title="item.name" class="undone-cell">
                                <van-field
                                    v-if="item.name == '身份证'"
                                    class="undone_inp"
                                    v-model="item.value"
                                    :maxlength="18"
                                    placeholder="请输入"/>
                                <van-field
                                    v-else
                                    class="undone_inp"
                                    v-model="item.value"
                                    placeholder="请输入"/>
                            </van-cell>
                            <van-cell v-if="item.flag === 2" @click="selectDate(item,index,cellIndex)" :title="item.name" class="undone-date" :value="item.value || '请选择'" is-link/>
                        </template>
                        <div class="auth-photos">
                            <div class="photo-title">上传照片</div>
                            <ul class="photos">
                                <li class="photos-li" v-for="(item, imgIndex) in authInfo.authTemImage" :key="item.id">
                                    <div class="photo_info">请上传{{item.imageInfo}}</div>
                                    <div class="photo_upload">
                                        <div
                                            class="upload_mdl"
                                            v-for="(temp, j) in item.myImage"
                                            :key="j"
                                            @click="openImage(imgIndex, j)">
                                            <img @click.stop="delImg(imgIndex, j)" v-if="!item.auditStatus&&j>0" class="close"
                                                 src="./img/guanbi.png" alt="">
                                            <van-image
                                                width="100%"
                                                height="100%"
                                                fit="cover"
                                                :src="temp"
                                            />
                                        </div>
                                        <div class="upload_mdl" v-if="item.myImage && item.myImage.length < 2">
                                            <template v-if="authInfo.certificateType==1">
                                                <!--实名认证 app版本>=5.0.8 有JSB相机，否则使用h5实名认证上传组件-->
                                                <div v-if="JsbAuth" class="jsb-camera" @click="handleJsb(imgIndex)">
                                                    <img class="jsb-camera--logo" src="./img/camera.png" alt="">
                                                    <div class="jsb-camera--word">点击上传</div>
                                                </div>
                                                <crop-upload v-else @uploadSuccess="uploadRealName" :dir="authInfo.certificateType | filterDir" :current-index="imgIndex" trans-cls="wh-one"/>
                                            </template>
                                            <Upload v-else @uploadSuccess="uploadAuth" :dir="authInfo.certificateType | filterDir" :current-index="imgIndex" trans-cls="wh-one" />
                                        </div>
                                    </div>
                                </li>
                            </ul>

                        </div>

                    </div>

                </div>
            </van-collapse-item>
        </van-collapse>

        <div class="bot-group">
            <van-button @click="submit" class="submit">完 成</van-button>
        </div>

        <AuthTipDialog v-model="hasAuthTip" @close="closeAuthTip"/>
        <DateTime dateType="date" :show="showDate" @cancel="showDate = false" @confirmTime="confirmDate"/>
        <CameraType :showCamera.sync="showCameraType" @selectJSB="selectJSB" @uploadH5Auth="uploadH5Auth"  :typeIndex="cameraTypeIndex" :dir="getJsbDir"/>
        <CertificateVersion v-model="hadSelectElectron" @dialogs="selectVersion" />
    </div>
</template>

<script>
    import {
        Toast,
        ImagePreview,
        Icon as VanIcon,
        Cell as VanCell,
        Field as VanField,
        Image as VanImage,
        Button as VanButton,
        Collapse as VanCollapse,
        CollapseItem as VanCollapseItem,
    } from 'vant';
    import AuthTipDialog from '@/components/AuthTipDialog/Index.vue'
    import Upload from '@/components/Upload/Upload.vue'
    import CropUpload from '@/components/CropUpload/CropUpload.vue'
    import DateTime from '@/components/DateTime/DateTime.vue'
    import CertificateVersion from '@/components/CertificateVersion/Index.vue'
    import CameraType from '@/components/CameraType/Index.vue'
    import {
        listCertificateByUserNurseId,
        getCertificateTemplateById,
        getUserNurseCertificate,
        saveUserNurseCertificate
    } from '@/api/authen.js'
    import {goScanCard,dataBuryingPoint} from '@/utils/JSBridge.js';
    import {getIdcard} from '@/api/idcard.js'
    import {cropPicture} from "@/utils/index.js";
    import ossDir from '@/config/ossUploadDir.js';

    export default {
        name: 'ServiceAuth',
        props: {
            JsbAuth: Boolean,
            isIphone: Boolean,
        },
        data() {
            return {
                activeIndex: 0,
                authTip: false,
                hasAuthTip: false,
                allAuthList: [], // 认证列表
                hadSelectElectron: false, // 显示选择电子版/纸质版弹窗
                hadElectron: false, // 有电子版
                isPaperVersion: true, // 是否纸质版
                showDate: false, // 打开选择日期组件
                elOneIndex: 0,
                elCellIndex: 0,
                showCameraType: false,
                cameraTypeIndex: 0,
                intTimer: null,
            }
        },
        methods: {
            closeAuthTip() {
                this.hasAuthTip = false;
            },
            submit() {
                let allAuthList = this.allAuthList;
                let hadSuccess = false;
                let postList = [];
                for (let i=0; i<allAuthList.length; i++) {
                    let authObj = allAuthList[i];
                    // 未审核或审核不通过
                    if (authObj.auditStatus && authObj.auditStatus!=2) {
                        continue;
                    }
                    let { authTemForm, authTemImage} = authObj;
                    // 表单，图片不完整，跳过本次循环
                    let emptyForm = false;
                    let emptyImage = false;
                    if (!authTemForm || !authTemImage) {
                        continue;
                    }
                    for (let i = 0; i < authTemForm.length; i++) {
                        if (!authTemForm[i].value) {
                            emptyForm = true;
                            break;
                        }
                    }
                    for (let i = 0; i < authTemImage.length; i++) {
                        if (!authTemImage[i].value) {
                            emptyImage = true;
                            break;
                        }
                    }
                    if (emptyImage||emptyForm) {
                        continue;
                    }
                    let params = {
                        electroFlag: authObj.selectedVersion=='electron' ? true : false,
                        certificateTemplateId: authObj.tempId,
                        listField: authObj.authTemForm.map(v => ({id: v.id, value: v.value, ocrValue: v.ocrValue})),
                        listImage: authObj.authTemImage.map(v => ({id: v.id, value: v.value})),
                    };
                    postList.push(params);
                    saveUserNurseCertificate(params).then(r => {
                        this.hadSuccess = true;
                    }).catch(e => {});
                    dataBuryingPoint('F000010', 'F000010-003', {id: authObj.tempId});
                }
                if (postList.length===0) {
                    Toast('请完善提交信息');
                    return;
                }
                this.intTimer = setInterval(v => {
                    if (this.hadSuccess) {
                        window.location.href = './submitReviewSuccess.html';
                    }
                }, 1000);
            },
            lookImage(position, timer) {
                // 打开图片[认证通过]
                let authIndex = this.activeIndex-1;
                let imageList = this.allAuthList[authIndex].disImgList;
                const instance = ImagePreview({
                    images: imageList,
                    asyncClose: !!timer,
                    closeOnPopstate: true,
                    startPosition: typeof position === 'number' ? position : 0
                });
                if (timer) {
                    setTimeout(() => {
                        instance.close();
                    }, timer);
                }
            },
            delImg(imgIndex, secIndex) {
                // 删除图片
                let authIndex = this.activeIndex-1;
                this.allAuthList[authIndex].authTemImage[imgIndex].value = '';
                this.allAuthList[authIndex].authTemImage[imgIndex].myImage.splice(secIndex);
            },
            openImage(index, position, timer) {
                // 打开图片[认证不通过]
                let authIndex = this.activeIndex-1;
                let imageList = this.allAuthList[authIndex].authTemImage[index].myImage;
                const instance = ImagePreview({
                    images: imageList,
                    asyncClose: !!timer,
                    closeOnPopstate: true,
                    startPosition: typeof position === 'number' ? position : 0
                });
                if (timer) {
                    setTimeout(() => {
                        instance.close();
                    }, timer);
                }
            },
            selectVersion(val) {
                // 选择纸质版或电子版
                let authIndex = this.activeIndex - 1;
                let authImage = this.allAuthList[authIndex].allAuthTemImage;
                if ('paper' === val) {
                    this.isPaperVersion = true;
                    let paperImage = [];
                    for (let i=0; i<authImage.length; i++) {
                        if (!authImage[i].electroFlag) {
                            paperImage.push(authImage[i])
                        }
                    }
                    this.$set(this.allAuthList[authIndex], 'authTemImage', paperImage);
                } else if ('electron' === val) {
                    this.isPaperVersion = false;
                    let electronImage = [];
                    for (let i=0; i<authImage.length; i++) {
                        if (authImage[i].electroFlag) {
                            electronImage.push(authImage[i])
                        }
                    }
                    this.$set(this.allAuthList[authIndex], 'authTemImage', electronImage);
                }
                this.$set(this.allAuthList[authIndex], 'selectedVersion', val);
                this.hadSelectElectron = false
            },
            getJsbUrl(url, type) {
                // 上传图片
                let index = type - 1;
                let authIndex = this.activeIndex-1;
                this.allAuthList[authIndex].authTemImage[index].value = url;
                // this.allAuthList[authIndex].authTemImage[index].myImage.push(url);
                this.allAuthList[authIndex].authTemImage[index].myImage.splice(1, 1, url);
                if (index === 0) {
                    this.matchIdcard(url);
                } else {
                    this.matchIdcard(url, false);
                }
            },
            uploadH5Auth(value) {
                console.log('value', value);
                let type = value.typeIndex + 1;
                this.getJsbUrl(value.url, type)
            },
            callJsbCamera(index) {
                /**
                 * 扫描身份证
                 * 1 正面，2 反面
                 * index = 0 正面， index = 1 反面
                 **/
                let type = index + 1;
                goScanCard(type);
            },
            selectJSB(index) {
                console.log('index', index);
                this.callJsbCamera(index);
            },
            handleJsb(index) {
                if (this.isIphone) {
                    this.cameraTypeIndex = index;
                    this.showCameraType = true;
                    return;
                }
                this.callJsbCamera(index);
            },
            matchIdcard(url, type = true) {
                // 身份证识别
                getIdcard({imgurl:url,isFace:type}).then(r => {
                    let cardInfo = JSON.parse(r);
                    if (type) {
                        let authIndex = this.activeIndex-1;
                        this.allAuthList[authIndex].authTemForm[0].value = cardInfo.name;
                        this.allAuthList[authIndex].authTemForm[0].ocrValue = cardInfo.name;
                        this.allAuthList[authIndex].authTemForm[1].value = cardInfo.num;
                        this.allAuthList[authIndex].authTemForm[1].ocrValue = cardInfo.num;
                    }
                }).catch(_ => {
                });
            },
            uploadRealName(url, index) {
                // 上传图片 [实名认证]
                let authIndex = this.activeIndex-1;
                let cropPath = cropPicture(url, 750);
                this.allAuthList[authIndex].authTemImage[index].value = url;
                // this.allAuthList[authIndex].authTemImage[index].myImage.push(cropPath);
                this.allAuthList[authIndex].authTemImage[index].myImage.splice(1, 1, cropPath);

                if (index === 0) {
                    this.matchIdcard(url);
                } else {
                    this.matchIdcard(url, false);
                }
            },
            uploadAuth(url, index) {
                // 上传图片 [非实名认证]
                let authIndex = this.activeIndex-1;
                let cropPath = cropPicture(url, 750);
                this.allAuthList[authIndex].authTemImage[index].value = url;
                // this.allAuthList[authIndex].authTemImage[index].myImage.push(cropPath);
                this.allAuthList[authIndex].authTemImage[index].myImage.splice(1, 1, cropPath);
            },
            changeAuth(val) {
                if (!val) return;
                let index = val-1;
                let authObj = this.allAuthList[index];
                // 通过
                if (authObj.auditStatus === 1) {
                    if(authObj.authTemForm&&authObj.authTemForm.length>0) return;
                    getUserNurseCertificate({id: authObj.id}).then(r => {
                        let disFiledList = r.listField.map(v => {
                            return {
                                name: v.name,
                                value: v.value,
                            }
                        });
                        let disImgList = r.listImage.map(v => cropPicture(v.imageUrl, 375));
                        this.$set(this.allAuthList[index], 'disFiledList', disFiledList);
                        this.$set(this.allAuthList[index], 'disImgList', disImgList);
                        dataBuryingPoint('F000010', 'F000010-002', {id: authObj.id});
                    }).catch(() => {});
                    return;
                }

                // 未审核，未通过
                if (authObj.hasElectro) {
                    // 有电子版，并且没有添加图片 -》电子版纸质版弹窗
                    let electroImage = authObj.authTemImage;
                    let noImg = true;
                    for (let i=0; i<electroImage.length; i++) {
                        if (electroImage[i].value) {
                            noImg = false;
                            break;
                        }
                    }
                    this.hadSelectElectron = noImg;
                }
                if(authObj.authTemForm&&authObj.authTemForm.length>0) return;
                if (authObj.auditStatus === 2) {
                    // 审核不通过，需要先获取模板id,再重新请求模板信息
                    getUserNurseCertificate({id: authObj.id}).then(r => {
                        this.getTemplate(r.certificateTemplateId, index);
                    }).catch(() => {});
                } else {
                    this.getTemplate(authObj.id, index);
                }
            },
            getTemplate(id, curIndex) {
                // 根据模板id获取模板
                getCertificateTemplateById({id: id}).then(r => {
                    let fieldList = [];
                    let imageList = [];
                    let hasElectro = r.hasElectro;
                    fieldList = r.field.map(v => {
                        return {
                            id: v.id,
                            name: v.name,
                            flag: v.flag,
                            value: '',
                            ocrValue: '', // 识别出的信息
                        }
                    });
                    if (hasElectro) {
                        this.hadSelectElectron = true;
                        imageList = r.image.map(v => {
                            let tempCrop = cropPicture(v.imageUrl, 375);
                            return {
                                id: v.id,
                                imageInfo: v.imageInfo,
                                imageUrl: v.imageUrl,
                                value: '',
                                electroFlag: v.electroFlag,
                                myImage: [tempCrop],
                            }
                        });
                        // 所有证书【电子版、纸质版】，记录全部数据用于下次切换
                        this.$set(this.allAuthList[curIndex], 'allAuthTemImage', imageList);
                    } else {
                        imageList = r.image.map(v => {
                            let tempCrop = cropPicture(v.imageUrl, 375);
                            return {
                                id: v.id,
                                imageInfo: v.imageInfo,
                                imageUrl: v.imageUrl,
                                value: '',
                                myImage: [tempCrop]
                            }
                        });
                    }
                    this.$set(this.allAuthList[curIndex], 'tempId', id);
                    this.$set(this.allAuthList[curIndex], 'hasElectro', hasElectro);
                    this.$set(this.allAuthList[curIndex], 'authTemForm', fieldList);
                    this.$set(this.allAuthList[curIndex], 'authTemImage', imageList);
                }).catch(() => {});
                dataBuryingPoint('F000010', 'F000010-002', {id: id});
            },
            confirmDate(val) {
                let authIndex = this.activeIndex-1;
                this.allAuthList[authIndex].authTemForm[this.elCellIndex].value = val;
                this.showDate = false;
            },
            selectDate(item, index, cellIndex) {
                // 开启日期选择器并记录当前索引
                let authIndex = this.activeIndex-1;
                this.elOneIndex = index;
                this.elCellIndex = cellIndex;
                if (!item.auditStatus) {
                    this.showDate = true;
                } else {
                    Toast('不可修改');
                }
            },
        },
        mounted() {
            let hadAuth = true;
            listCertificateByUserNurseId().then(r => {
                for (let i = 0; i < r.length; i++) {
                    let authTypeList = r[i].listUserNurseCertificateAppVO;
                    if (r[i].certificateType === 1) {
                        this.allAuthList.push(...authTypeList);
                    } else if (r[i].certificateType === 2) {
                        this.allAuthList.push(...authTypeList);
                        for (let j=0; j<authTypeList.length; j++) {
                            if (authTypeList[j].auditStatus) {
                                hadAuth = false;
                                break;
                            }
                        }
                        this.hasAuthTip = hadAuth;
                        console.log('hasAuthTip', this.hasAuthTip)
                    }
                }
            }).catch(() => {});

        },
        destroyed() {
            clearInterval(this.intTimer);
        },
        computed: {
            getJsbDir() {
                let val = this.activeIndex;
                if (val === 1) {
                    return ossDir.userCertifyName
                } else if (val === 2) {
                    return ossDir.userCertifyBase
                } else if (val === 3) {
                    return ossDir.userCertifyProfession
                }
                return '';
            }
        },

        filters: {
            filterDir(val) {
                if (val === 1) {
                    return ossDir.userCertifyName
                } else if (val === 2) {
                    return ossDir.userCertifyBase
                } else if (val === 3) {
                    return ossDir.userCertifyProfession
                }
            },
        },

        components: {
            VanCollapse,VanCollapseItem,VanIcon,VanCell,VanField,VanImage,VanButton,ImagePreview,
            AuthTipDialog,Upload,CropUpload,DateTime,CertificateVersion,CameraType,
        },
    }
</script>

<style lang="scss" scoped>
    #ServiceAuth {
        padding: 0 16px 60px;

        .service-title {
            font-size:24px;
            font-weight:500;
            color:rgba(75,76,76,1);
            margin-bottom: 0;
        }

        .service-desc {
            padding-top: 13px;
            font-size:14px;
            font-weight:400;
            color:rgba(153,153,153,1);
        }
        .service-tip {
            padding-top: 6px;
            font-size:14px;
            font-weight:400;
            color:rgba(153,153,153,1);
            strong {
                color: #222222;
            }
        }

        .authCollapse {
            margin-top: 20px;

            .collapse-mdl {
                background: rgba(255, 255, 255, 1);
                border: 1px solid rgba(255, 255, 255, 1);
                border-radius: 3px;
                box-shadow: 0 0 6px rgba(0, 0, 0, .15);
                overflow: hidden;
                min-height: 87px;
                margin-bottom: 17px;
                padding-top: 10px;
                /*display: flex;*/
                /*align-items: center;*/

                .major_title {
                    font-size: 18px;
                    font-weight: 500;
                    color: rgba(34, 34, 34, 1);
                }

                .sub_title {
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(134, 135, 135, 1);
                    line-height: 21px;
                }

                .btn_title {
                    display: flex;
                    align-items: center;
                    justify-content: right;
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(34, 34, 34, 1);
                    .review {
                        color:rgba(153,153,153,1);
                    }
                    .arrow {
                        width: 12px;
                        margin-left: 8px;
                        transition: transform 0.3s,-webkit-transform 0.3s;
                    }
                }

                .auth-content {
                    .done {
                        &-cell {
                            align-items: center;
                            padding: 15px 15px;
                        }
                        .picture-list {
                            padding: 3px 14px;

                            .picture {
                                width: 100%;
                                margin: 16px 0;
                            }
                        }
                    }
                    .undone {
                        &-cell {
                            align-items: center;
                            .undone_inp {
                                padding: 5px 15px;
                            }
                        }
                        &-date {
                            align-items: center;
                            padding: 15px 15px;
                        }

                        .auth-photos {
                            background: rgba(255, 255, 255, 1);
                            padding-left: 16px;
                            padding-right: 16px;
                            .photo-title {
                                padding-top: 20px;
                                font-size: 17px;
                                font-weight: 500;
                                color: rgba(34, 34, 34, 1);
                            }
                            .photos {
                                padding-top: 18px;
                                padding-left: 16px;
                                list-style: disc;
                                color: rgba(105, 112, 127, 1);

                                &-li {
                                    margin-bottom: 20px;

                                    .photo_info {
                                        font-size: 15px;
                                        font-weight: 300;
                                        padding-bottom: 16px;
                                    }

                                    .photo_upload {
                                        display: flex;
                                        align-items: center;
                                        justify-content: space-between;
                                        margin-left: -16px;
                                        overflow: hidden;

                                        .upload_mdl {
                                            width: 143px;
                                            height: 104px;
                                            position: relative;

                                            .close {
                                                position: absolute;
                                                top: 0;
                                                right: 0;
                                                width: 17px;
                                                height: 17px;
                                                z-index: 10;
                                            }

                                            .upload-content {
                                                width: 160px;
                                                height: 116px;
                                            }

                                            .jsb-camera {
                                                width: 143px;
                                                height: 104px;
                                                background:rgba(243,245,249,1);
                                                display: flex;
                                                flex-direction: column;
                                                align-items: center;
                                                justify-content: center;

                                                &--logo {
                                                    width: 32px;
                                                    height: 26px;
                                                }
                                                &--word {
                                                    margin-top: 6px;
                                                    font-size:12px;
                                                    font-weight:500;
                                                    color:rgba(105,112,127,1);
                                                }

                                            }
                                        }
                                    }
                                }

                            }

                        }
                    }
                }
            }
        }
        .bot-group {
            position: fixed;
            bottom: 0;
            left: 0;
            display: flex;
            justify-content: space-between;
            width: 100%;
            padding: 10px 16px;
            box-sizing: border-box;
            z-index: 100;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0 -1px 8px rgba(0, 0, 0, .1);
            .submit {
                flex: 1;
                background: #FFC600;
                font-weight: 400;
                text-shadow: 0 1px 2px rgba(69, 0, 8, 0.2);
                font-size:16px;
                color:rgba(43,21,0,1);
                border: none;
                border-radius:3px;
            }
        }


    }
</style>

<style lang="scss">
    #ServiceAuth {

        .authCollapse {
            .van-hairline--top-bottom::after {
                border: none;
            }
            .van-hairline--top::after {
                border: none;
            }
        }
        .van-collapse-item__content {
            padding: 0;
        }

        .van-collapse-item__title--expanded {
            .arrow_rotate {
                transform: rotate(-180deg);
            }
        }
        .undone_inp {
            .van-field__control {
                text-align: right;
            }
        }
    }
</style>
